import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import Captcha from "@/components/Captcha";
import { api, errMsg } from "@/lib/api";

export default function ForgotPasswordDialog({ open, onOpenChange, note = "", captchaId = "forgot-captcha", scope = "customer" }) {
  const [mobile, setMobile] = useState("");
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (!ok) return toast.error("Please solve the code challenge first");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { mobile, scope });
      toast.success(data.message);
      onOpenChange(false);
      setMobile("");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl sm:max-w-md" data-testid="forgot-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">Forgot password</DialogTitle>
          <DialogDescription>Enter your registered mobile number. If the account is active, we'll text you your login ID and a new temporary password.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label className="text-xs font-semibold text-slate-600">Registered mobile number</Label>
            <Input className="h-11" inputMode="tel" placeholder="024 123 4567" value={mobile} onChange={(e) => setMobile(e.target.value)} data-testid="forgot-mobile-input" />
          </div>
          <Captcha onValid={setOk} testid={captchaId} />
          <Button disabled={busy || !mobile} onClick={submit} className="h-11 w-full rounded-xl bg-[#0052FF] font-bold hover:bg-[#0041CC] btn-press" data-testid="forgot-submit-button">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Send my login by SMS"}
          </Button>
          {note && <p className="text-center text-xs text-slate-400">{note}</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
}
